export enum ShippingInHouseEnum {
  MAIN = '1', // 本社
  OKINAWA = '2', // 沖縄
}

export const ShippingInHouse = [
  { label: '本社', value: ShippingInHouseEnum.MAIN },
  { label: '沖縄', value: ShippingInHouseEnum.OKINAWA },
];
